import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, input } from '@angular/core';
import { isNullOrUndefined } from '../../utils';

@Component({
  selector: 'trg-editor-container',
  templateUrl: './trg-editor-container.component.html',
  styleUrls: ['./trg-editor-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SharedTrgEditorContainerComponent implements OnChanges {
  @Input() toolbarHeight: number = 56;
  @Input() constrainContent = false;
  
  readonly contentClass = input('');

  toolbarStyle = '';
  contentStyle = '';

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.toolbarHeight || changes.constrainContent) {
      let toolbarHasHeight = !isNullOrUndefined(this.toolbarHeight);

      this.toolbarStyle = toolbarHasHeight ? `flex: 0 0 ${this.toolbarHeight}px` : '';
      this.contentStyle = this.constrainContent && toolbarHasHeight ? `max-height: calc(100% - ${this.toolbarHeight}px)` : '';
    }
  }
}
